import { Box, useScaleFactor, useTheme } from "arkh";
import React from "react";

export function ResolvedCircle(props: { isResolved: boolean }) {
  const theme = useTheme();
  const sf = useScaleFactor();
  const size = Math.floor(18 * sf);

  return (
    <Box
      style={{
        borderColor: props.isResolved ? theme.positive : theme.negative,
        borderWidth: 2 * sf,
        backgroundColor: "#FFF",
        borderRadius: size / 2,
        width: size,
        height: size,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        color={props.isResolved ? "positive" : "transparent"}
        style={{
          borderRadius: 20 * sf,
          width: 10 * sf,
          height: 10 * sf,
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    </Box>
  );
}
